export default __webpack_public_path__ + "static/media/trivia-game.81799b47.png";